export interface PriceBreakupDiscountInput {
  discountValue: number | null;
  makingChargeDiscountValue: number | null;
  discountOnDiamondPriceValue: number | null;
  makingChargePrice: number | null;
  makingChargePriceAfterDiscount: number | null;
  diamondPrice: number | null;
  diamondPriceAfterDiscount: number | null;
}

export function hasComponentDiscount({
  makingChargeDiscountValue,
  discountOnDiamondPriceValue,
  makingChargePrice,
  makingChargePriceAfterDiscount,
  diamondPrice,
  diamondPriceAfterDiscount,
}: PriceBreakupDiscountInput): boolean {
  return (
    ((makingChargeDiscountValue ?? 0) > 0 &&
      makingChargePrice !== null &&
      makingChargePriceAfterDiscount !== null) ||
    ((discountOnDiamondPriceValue ?? 0) > 0 &&
      diamondPrice !== null &&
      diamondPriceAfterDiscount !== null)
  );
}

export function computeDiscountOnProduct({
  discountValue,
  makingChargeDiscountValue,
  discountOnDiamondPriceValue,
  makingChargePrice,
  makingChargePriceAfterDiscount,
  diamondPrice,
  diamondPriceAfterDiscount,
}: PriceBreakupDiscountInput): number {
  if (!discountValue) return 0;

  let discountOnProduct = discountValue;

  if (
    (makingChargeDiscountValue ?? 0) > 0 &&
    makingChargePrice !== null &&
    makingChargePriceAfterDiscount !== null
  ) {
    discountOnProduct -= makingChargePrice - makingChargePriceAfterDiscount;
  }

  if (
    (discountOnDiamondPriceValue ?? 0) > 0 &&
    diamondPrice !== null &&
    diamondPriceAfterDiscount !== null
  ) {
    discountOnProduct -= diamondPrice - diamondPriceAfterDiscount;
  }

  return Math.max(0, discountOnProduct);
}

export function computeGstToShow(
  gst: number | null,
  flatDiscountPercent: number | null,
  discountOnProduct: number,
  componentDiscountApplied: boolean
): number | null {
  if (gst === null) return null;
  if ((flatDiscountPercent ?? 0) > 0) return gst;
  if (!componentDiscountApplied) return gst;
  return Math.max(0, gst - discountOnProduct);
}
